<template>
    <div id="pageNotFoundContent">
      <h1>Page not found</h1>
      <p>You can return to the <a href="https://www.qld.gov.au/rbdm">home page</a> and look for links to the information</p>
    </div>
</template>

<script>

export default {
  name: 'NotFound'
}
</script>

<style scoped lang="scss">
#pageNotFoundContent {
  min-height: 20em;
}
</style>